import { render, staticRenderFns } from "./addServiceRule.vue?vue&type=template&id=1d7f1ce6&scoped=true"
import script from "./addServiceRule.vue?vue&type=script&lang=js"
export * from "./addServiceRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7f1ce6",
  null
  
)

export default component.exports